import axios from 'axios'

const MINORS_HOST = 'https://minors.winwinapp.ru'
const API_HOST = process.env.NODE_ENV === 'development' ? 'http://localhost:3004' : 'https://d1.winwinapp.ru'

export default  {
  getHidingFieldsConfig(domain) {
    return axios
      .get(`${MINORS_HOST}/settings/field/${domain}`)
      .then(res => res.data)
      .catch(e => {
        console.error(e)
        return null
      })
  },
  getUploadsConfig(domain) {
    return axios
      .get(`${API_HOST}/config/uploads/${domain}`)
      .then(res => res.data)
      .catch(e => {
        console.error(e)
        return null
      })
  },
  getPresentation({ domain, managerId, pId, ids }) {
    return axios
      .get(`/api/${domain}/${managerId}`, {
        params: {
          pId,
          ids,
        },
      })
      .then((res) => res.data.data)
  },
}
